import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppConstants } from './app.constants';
import { ActivatedRoute, Params, Router, RouterModule, RouterOutlet } from '@angular/router';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

import { LayoutModule } from '@progress/kendo-angular-layout';
import { FormsModule } from '@angular/forms';
import { IconsModule } from '@progress/kendo-angular-icons';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

import { datadogRum } from '@datadog/browser-rum';
import { TccSpinnerComponent } from './shared/components/tcc-spinner/tcc-spinner.component';
import { CommonModule } from '@angular/common';
import { UserDTO } from './models/UserDTO.model';
import { IAppSettings } from './models/app-settings.model';
import { AuthService } from './services/auth.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FileManagerService } from './services/file-manager.service';
import { RegionsDto } from './models/Regions.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [
      TranslateModule,
    RouterOutlet,
    RouterModule,
    TccSpinnerComponent,
    CommonModule,
    FormsModule,
    LayoutModule,
    IconsModule,
    InputsModule,
    LabelModule,
    ButtonsModule,
    DropDownsModule,
],
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
  private appSettings: IAppSettings = (<any>window)[AppConstants.AppSettings];
  public appConstants: typeof AppConstants = AppConstants;
  title = 'TCC Reports';
  isProgressBarShown = false;
  isHeaderVisible: any;
  constructor(
    private authService: AuthService,
    public translate: TranslateService,
    private route: ActivatedRoute,
     private fileService: FileManagerService
  ) { }
  ngOnInit() {
    dayjs.extend(timezone);
    // set HK timezone
    dayjs.tz.setDefault('Asia/Hong_Kong');
    localStorage.setItem('locale', "zh-HK");
    this.translate.setDefaultLang(localStorage.getItem('locale')!);
    this.translate.use(localStorage.getItem('locale')!);
    //Receive shared Message
    console.log(this)
    window.addEventListener('message', this.receiveMessage.bind(this), false);
    this.authService.accessToken = localStorage.getItem('TCC.Token')!;
    const userInfo = JSON.parse(localStorage.getItem('userInfo')!);
    this.datadogSetUser(userInfo);
     this.fileService.getFileStorageRegions()
  }
  receiveMessage(event: MessageEvent) {
    const trustedOrigin = this.appSettings.tccWebAppUrl;
    if (event.origin !== trustedOrigin) {
      console.warn('Received message from untrusted origin:', event.origin);
      return;
    }
    console.warn('Received message from trusted origin:', event);
    console.warn('Received message from trusted origin:', event.data);

    try {
      localStorage.setItem('TCC.Token', event.data.token);
      localStorage.setItem('userInfo', JSON.stringify(event.data.userInfo));
      if(event.data.jobIdentity)
        localStorage.setItem('jobIdentity', event.data.jobIdentity);
    } catch (e) {
      console.error('LocalStorage is blocked in Incognito mode:', e);
      alert('LocalStorage is blocked in Incognito mode:')
    }

  }
  private datadogSetUser(data: UserDTO) {
    const userData: UserDTO = data;
    datadogRum.setUser({
      id: userData?.userId.toString(),
      name: userData?.name,
    });
    datadogRum.setUserProperty('team', userData?.teamName);
    datadogRum.setUserProperty('locationId', userData?.locationId);
  }

}
